enum BevelOptionsEnum {
    No = 'NO',
    Internal = 'INTERNAL',
    External = 'EXTERNAL',
}

export default BevelOptionsEnum;
